import React from 'react'
import { getMessage } from '../../../utils/index'
import { Card } from 'primereact/card'
import { Checkbox } from 'primereact/checkbox'
import { FileUpload } from 'primereact/fileupload'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import _ from 'lodash'

import './CertificadoDigitalForm.scss'

export const CertificadoDigitalForm = (props) => {
  const record = props.record
  const messages = props.messages

  return (
    <div className="p-grid p-fluid certificado-digital-form">
      <div className="p-col-12">
        <Card title={`${getMessage(messages, 'certificadodigital.label.certificadodigital')} ${record.oid || ''}`}>
          {/* Seção de Upload de Certificado */}
          <div className="p-grid form-group">
            <div className="p-col-12">
              <h3>{getMessage(messages, 'certificadodigital.label.uploadcertificado')}</h3>
              <p className="help-text">
                {getMessage(messages, 'certificadodigital.label.uploadhelp')}
              </p>
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <label>{getMessage(messages, 'certificadodigital.label.arquivocertificado')}</label>
              <FileUpload
                name="file"
                customUpload
                uploadHandler={props.onUploadCertificado}
                accept=".pfx,.p12"
                maxFileSize={10000000}
                chooseLabel={getMessage(messages, 'certificadodigital.label.selecionararquivo')}
                uploadLabel={getMessage(messages, 'certificadodigital.label.extrairdados')}
                cancelLabel={getMessage(messages, 'certificadodigital.label.cancelar')}
                auto={false}
              />
            </div>
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={props.certificadoPassword}
                onChange={(e) => props.onChangeCertificadoPassword(e)}
                name="certificadoPassword"
                type="password"
                label={getMessage(messages, 'certificadodigital.label.senhacertificado')}
              />
            </div>
          </div>

          <div className="p-divider" />

          {/* Informações do Titular */}
          <div className="p-grid form-group">
            <div className="p-col-12">
              <h3>{getMessage(messages, 'certificadodigital.label.informacoestitutar')}</h3>
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={_.get(record, 'dadosTitular.commonName', '')}
                onChange={(e) => props.onChangeField('dadosTitular.commonName', e)}
                name="dadosTitular.commonName"
                maxLength={255}
                label={getMessage(messages, 'certificadodigital.label.commonname')}
                disabled
              />
            </div>
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={_.get(record, 'dadosTitular.organization', '')}
                onChange={(e) => props.onChangeField('dadosTitular.organization', e)}
                name="dadosTitular.organization"
                maxLength={255}
                label={getMessage(messages, 'certificadodigital.label.organizacao')}
                disabled
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={_.get(record, 'dadosTitular.locality', '')}
                onChange={(e) => props.onChangeField('dadosTitular.locality', e)}
                name="dadosTitular.locality"
                maxLength={255}
                label={getMessage(messages, 'certificadodigital.label.localidade')}
                disabled
              />
            </div>
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={_.get(record, 'dadosTitular.state', '')}
                onChange={(e) => props.onChangeField('dadosTitular.state', e)}
                name="dadosTitular.state"
                maxLength={255}
                label={getMessage(messages, 'certificadodigital.label.estado')}
                disabled
              />
            </div>
          </div>

          <div className="p-divider" />

          {/* Informações do Emissor */}
          <div className="p-grid form-group">
            <div className="p-col-12">
              <h3>{getMessage(messages, 'certificadodigital.label.informacoesemissor')}</h3>
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={_.get(record, 'dadosEmissor.commonName', '')}
                onChange={(e) => props.onChangeField('dadosEmissor.commonName', e)}
                name="dadosEmissor.commonName"
                maxLength={255}
                label={getMessage(messages, 'certificadodigital.label.commonname')}
                disabled
              />
            </div>
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={_.get(record, 'dadosEmissor.organization', '')}
                onChange={(e) => props.onChangeField('dadosEmissor.organization', e)}
                name="dadosEmissor.organization"
                maxLength={255}
                label={getMessage(messages, 'certificadodigital.label.organizacao')}
                disabled
              />
            </div>
          </div>

          <div className="p-divider" />

          {/* Validade */}
          <div className="p-grid form-group">
            <div className="p-col-12">
              <h3>{getMessage(messages, 'certificadodigital.label.validadecertificado')}</h3>
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-3">
              <LtsCalendar
                value={record.dataInicio}
                onChange={(e) => props.onChangeField('dataInicio', e)}
                name="dataInicio"
                label={getMessage(messages, 'certificadodigital.label.datainicio')}
                disabled
              />
            </div>
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-3">
              <LtsCalendar
                value={record.dataExpiracao}
                onChange={(e) => props.onChangeField('dataExpiracao', e)}
                name="dataExpiracao"
                label={getMessage(messages, 'certificadodigital.label.dataexpiracao')}
                disabled
              />
            </div>
          </div>

          <div className="p-divider" />

          {/* Chaves */}
          <div className="p-grid form-group">
            <div className="p-col-12">
              <h3>{getMessage(messages, 'certificadodigital.label.chavescertificado')}</h3>
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
              <label>{getMessage(messages, 'certificadodigital.label.chavepublica')}</label>
              <textarea
                className="p-inputtextarea p-inputtext p-component"
                rows={10}
                value={record.chavePublica}
                onChange={(e) => props.onChangeField('chavePublica', e.target.value)}
                placeholder="-----BEGIN CERTIFICATE-----&#10;...&#10;-----END CERTIFICATE-----"
                disabled
              />
            </div>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
              <label>{getMessage(messages, 'certificadodigital.label.chaveprivada')}</label>
              <textarea
                className="p-inputtextarea p-inputtext p-component"
                rows={10}
                value={record.chavePrivada}
                onChange={(e) => props.onChangeField('chavePrivada', e.target.value)}
                placeholder="-----BEGIN PRIVATE KEY-----&#10;...&#10;-----END PRIVATE KEY-----"
                disabled
              />
            </div>
          </div>

          <div className="p-divider" />

          {/* Ativo */}
          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <Checkbox
                checked={record.ativo}
                onChange={(e) => props.onChangeField('ativo', e)}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label htmlFor="chkativo" className="label">
                {getMessage(messages, 'certificadodigital.label.ativo')}
              </label>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
